import { useTranslation } from '../hooks/useTranslation';

const LoginPage = ({
  username,
  password,
  loading,
  error,
  handleLogin,
  setUsername,
  setPassword
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: '400px' }}>
        <h1 className="text-center mb-4">{t('login.title')}</h1>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">{t('login.username')}</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-person"></i></span>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="form-control"
                placeholder={t('login.usernamePlaceholder')}
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">{t('login.password')}</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-lock"></i></span>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control"
                placeholder={t('login.passwordPlaceholder')}
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`btn btn-primary w-100 ${loading ? 'disabled' : ''}`}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t('login.submitting')}
              </>
            ) : (t('login.submit'))}
          </button>
        </form>
        {error && (<div className="alert alert-danger mt-3" role="alert">{t('common.error')}: {error}</div>)}
      </div>
    </div>
  );
};

export default LoginPage;
